<template>
  <div class="news_view_mobile" v-loading="loading">
    <transition name="slide-fade">
      <top_mobile v-show="topshow"></top_mobile>
    </transition>
    <div style="height: 44px;background: #202334"></div>
    <div class="title">
      <i class="el-icon-arrow-left" style="font-size: 14px;font-weight: bold;" @click="goback()"></i>
      最新资讯
    </div>

    <div v-html="wechatCnt" class="cnt-area"></div>

    <div class="recommend-cntr" v-if="showRecommend">
      <p class="header-title">热点文章</p>
      <div class="article-title-cntr"
           v-for="(item, index) of articleTitle"
           :key="item.id"
           @click="toOtherArticle(item.id)"
      >
        <p class="index"
           :class="{top3_index: index < 3}"
           v-if="index < 9"
        >
          {{ index + 1 }}
        </p>
        <p class="index"
           :class="{top3_index: index < 3}"
           v-else
           style="margin-left: -5px; margin-right: 5px; margin-bottom: 100px"
        >
          {{ index + 1 }}
        </p>
        <p class="article-title">{{ item.title }}</p>
      </div>
    </div>

  </div>
</template>

<script>
import top_mobile from "../components/top_mobile";
import {auth} from "../request/api";
import news from "../../public/statics/newsdata.json";

export default {
  name: "news_view_mobile",
  components: {
    top_mobile
  },
  data() {
    return {
      topshow: true,
      loading: true,
      wechatCnt: '',
      articleTitle: [],
      showRecommend: false,
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScrollx, true)
    setTimeout(() => {
      this.loading = false;
    }, 500)

    this.get_url_content(this.$route.query.url)
    this.get_article_list()
  },
  methods: {
    handleScrollx() {
      if (window.pageYOffset > 0) {
        this.topshow = false;
      } else {
        this.topshow = true;
      }
    },

    goback() {
      this.$router.go(-1);
    },

    get_url_content(wechatUrl) {
      let url = '/index/web/get_url_content'
      let data = {
        url: wechatUrl
      }
      auth(url, data).then(res => {
        if (res.data.code == 1) {
          let tmp = res.data.data

          tmp = tmp.replaceAll('data-src', 'src')
          tmp = tmp.replace(`id="js_content" style="visibility: hidden;"`, `id="js_content"`)

          this.wechatCnt = tmp
          this.$nextTick(() => {
            this.showRecommend = true
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    get_article_list() {
      this.articleTitle = []
      let counter = 0
      for (let item of news.newslist) {
        this.articleTitle.push({title: item.title, id: item.id})
        counter++
        if (counter == 10) {
          break;
        }
      }
    },

    toOtherArticle(id) {
      if (id > 9) {
        let url = news.newslist[news.newslist.length - id - 1].url
        this.get_url_content(url)
        document.body.scrollTop = document.documentElement.scrollTop = 0;

      } else if (id >= 0) {
        this.$router.push({
          path: '/newviewsdetails_mobile',
          query: {
            id,
          }
        })
      }
    }
  }
}

</script>

<style scoped lang="scss">
.news_view_mobile {
  position: relative;

  .title {
    width: calc(100% - 2rem);
    box-sizing: border-box;
    height: 45px;
    text-align: left;
    line-height: 45px;
    font-size: 16px;
    color: #444444;
    margin: 0.5rem 1rem;
    border-bottom: 1px solid #E5E5E5;
  }

  .recommend-cntr {
    width: 80vw;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);

    .header-title {
      text-align: left;
      font-size: 20px;
      font-weight: bold;
      margin: 0;
      border-bottom: 2px solid DimGray;
    }

    .header-title:before {
      content: '|';
      margin-right: 10px;
      font-size: 20px;
      font-weight: bold;
      color: red;
    }

    .article-title-cntr {
      display: flex;
      text-align: left;
      line-height: 30px;
      font-size: 14px;
      cursor: pointer;

      .index {
        width: 25px;
        font-size: 20px;
        font-weight: bold;
      }

      .top3_index {
        color: red;
        font-size: 22px;
      }

      .article-title {
        width: calc(100% - 25px);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .article-title:hover {
        color: dodgerblue;
      }
    }
  }
}
</style>
